import type { AppRouteGroup } from 'app/store/components/NavigationUtils';

import ActivitiesConfig from './activities/ActivitiesConfig';
import ChronologyConfig from './chronology/ChronologyConfig';
import CommercialCampaignsConfig from './commercialcampaigns/CommercialCampaignsConfig';
import CompaniesConfig from './companies/CompaniesConfig';
import ContractsConfig from './contracts/ContractsConfig';
import DemsConfig from './dems/DemsConfig';
import ErpOrdersConfig from './erp-orders/ErpOrdersConfig';
import ErpQuotationsConfig from './erp-quotations/ErpQuotationsConfig';
import GroupsConfig from './groups/GroupsConfig';
import ItemsConfig from './items/ItemsConfig';
import MarketingActionsConfig from './marketingactions/MarketingActionsConfig';
import OpportunitiesConfig from './opportunities/OpportunitiesConfig';
import OrdersConfig from './orders/OrdersConfig';
import PeopleConfig from './people/PeopleConfig';
import ProjectsConfig from './projects/ProjectsConfig';
import TicketsConfig from './tickets/TicketsConfig';
import UsersConfig from './users/UsersConfig';
import WorkReportsConfig from './workreports/WorkReportsConfig';

const modulesConfigs: AppRouteGroup[] = [
	ActivitiesConfig,
	ChronologyConfig,
	CommercialCampaignsConfig,
	CompaniesConfig,
	ContractsConfig,
	DemsConfig,
	ErpOrdersConfig,
	ErpQuotationsConfig,
	GroupsConfig,
	ItemsConfig,
	MarketingActionsConfig,
	OpportunitiesConfig,
	OrdersConfig,
	PeopleConfig,
	ProjectsConfig,
	TicketsConfig,
	UsersConfig,
	WorkReportsConfig
];

export default modulesConfigs;
